var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 405.45 164.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "currentColor",
    d: "M192.51,121.85v9.41a10.87,10.87,0,0,1-10.87,10.86H102a10.86,10.86,0,0,1-10.86-10.86v-9.41a30.42,30.42,0,0,1,30.41-30.41h3.78a39.39,39.39,0,0,0,33,0h3.77A30.42,30.42,0,0,1,192.51,121.85ZM112.86,55.23a29,29,0,1,1,29,29A29,29,0,0,1,112.86,55.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "currentColor",
    d: "M314.31,121.85v9.41a10.86,10.86,0,0,1-10.86,10.86H223.8a10.86,10.86,0,0,1-10.86-10.86v-9.41a30.42,30.42,0,0,1,30.41-30.41h3.78a39.39,39.39,0,0,0,33,0h3.78A30.42,30.42,0,0,1,314.31,121.85ZM234.66,55.23a29,29,0,1,1,29,29A29,29,0,0,1,234.66,55.23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser02);
export default __webpack_public_path__ + "static/media/user_02.8a57201d.svg";
export { ForwardRef as ReactComponent };